import React from 'react';
import { REPORT } from '../print/PrintAtoms';
import type { OperatorCarveOut } from '../../lib/api';

interface Props {
  carveOut: OperatorCarveOut;
  representativeParcelLabel?: string | null;
}

export const CandidateCarveOutPanel: React.FC<Props> = ({ carveOut, representativeParcelLabel }) => {
  const acresLabel = carveOut.totalAcres
    ? `${Math.round(carveOut.totalAcres).toLocaleString()} ac`
    : null;
  const parcelCount = carveOut.parcelIds?.length ?? 0;

  return (
    <div
      style={{
        marginBottom: '14px',
        padding: '12px 14px',
        border: `1px solid ${REPORT.pass}40`,
        background: REPORT.passWash,
        borderRadius: '4px',
        fontSize: '11px',
        lineHeight: 1.55,
        color: REPORT.body,
      }}
    >
      <div
        style={{
          fontSize: '9px',
          fontWeight: 700,
          color: REPORT.passText,
          letterSpacing: '0.06em',
          marginBottom: '6px',
        }}
      >
        CANDIDATE CARVE-OUT
        {carveOut.positionLabel ? (
          <span style={{ color: REPORT.tertiary, marginLeft: '8px', fontWeight: 500 }}>
            · {carveOut.positionLabel}
          </span>
        ) : null}
      </div>

      <div
        style={{
          fontSize: '14px',
          fontWeight: 600,
          color: REPORT.heading,
          marginBottom: '6px',
        }}
      >
        {carveOut.name}
      </div>

      <div
        style={{
          display: 'flex',
          gap: '14px',
          flexWrap: 'wrap',
          marginBottom: '8px',
          fontSize: '10.5px',
        }}
      >
        {acresLabel ? (
          <div>
            <span style={{ color: REPORT.tertiary }}>Acres: </span>
            <strong>{acresLabel}</strong>
          </div>
        ) : null}
        {parcelCount > 0 ? (
          <div>
            <span style={{ color: REPORT.tertiary }}>Member parcels: </span>
            <strong>{parcelCount}</strong>
          </div>
        ) : null}
        <div>
          <span style={{ color: REPORT.tertiary }}>Owner: </span>
          <strong>{carveOut.ownerName}</strong>
        </div>
        {representativeParcelLabel ? (
          <div>
            <span style={{ color: REPORT.tertiary }}>Briefed parcel: </span>
            <strong>{representativeParcelLabel}</strong>
          </div>
        ) : null}
      </div>

      {carveOut.description ? (
        <div style={{ color: REPORT.body, marginBottom: '8px' }}>{carveOut.description}</div>
      ) : null}

      {carveOut.subdivisionNote ? (
        <div
          style={{
            marginTop: '8px',
            padding: '8px 10px',
            background: REPORT.white,
            borderLeft: `3px solid ${REPORT.pass}`,
            fontSize: '10.5px',
            color: REPORT.body,
            fontStyle: 'italic',
          }}
        >
          {carveOut.subdivisionNote}
        </div>
      ) : null}
    </div>
  );
};
